const BorderedButton = ({onClick, text, hasLoading = false, loading, customRender, additionalClass = '', ...rest}) => {
    return (
        <button onClick={onClick} className={`text-primary border border-primary font-bold py-2.5 px-6 rounded-xl flex flex-row items-center justify-center ${additionalClass}`}>
            {text}
        </button>
    )
}

export default BorderedButton